module.exports = __webpack_public_path__ + "assets/img/goal-check.c66006cc.svg";